export const VALID_CHART_TYPES = ["bar", "line", "text"] as const;
export type ChartType = (typeof VALID_CHART_TYPES)[number];

export const VALID_NODE_TYPES = [
  "string",
  "numeric",
  "binary",
  "json",
] as const;
export type NodeType = (typeof VALID_NODE_TYPES)[number];

export class DashboardTileNode {
  private id: string;
  private name: string;
  private chart_type: ChartType;
  private type: NodeType;

  constructor(id: string, name: string, chart_type: ChartType, type: NodeType) {
    this.setId(id);
    this.setName(name);
    this.setChartType(chart_type);
    this.setType(type);
  }

  getId(): string {
    return this.id;
  }

  getName(): string {
    return this.name;
  }

  getChartType(): ChartType {
    return this.chart_type;
  }

  getType(): NodeType {
    return this.type;
  }

  setId(id: string) {
    if (!id.trim()) {
      throw new Error("ID cannot be empty or whitespace.");
    }
    this.id = id;
  }

  setName(name: string) {
    if (!name.trim()) {
      throw new Error("Name cannot be empty or whitespace.");
    }
    this.name = name;
  }

  setChartType(chart_type: ChartType) {
    if (!VALID_CHART_TYPES.includes(chart_type)) {
      throw new Error(
        `Invalid chart_type value. Must be one of: ${VALID_CHART_TYPES.join(
          ", ",
        )}`,
      );
    }
    this.chart_type = chart_type;
  }

  setType(type: NodeType) {
    if (!VALID_NODE_TYPES.includes(type)) {
      throw new Error(
        `Invalid node type value. Must be one of: ${VALID_NODE_TYPES.join(
          ", ",
        )}`,
      );
    }
    this.type = type;
  }

  toJSON() {
    return {
      id: this.id,
      name: this.name,
      chart_type: this.chart_type,
      type: this.type,
    };
  }
}
